import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import VerifiedMethodSelection from './views/VerifiedMethodSelection';
import EnterSecurityCode from './views/EnterSecurityCode';
;
export var Views;

(function (Views) {
  Views["VerifiedMethodSelection"] = "VerifiedMethodSelection";
  Views["EnterSecurityCode"] = "EnterSecurityCode";
})(Views || (Views = {}));

export var TwoFactorAuthentication = function TwoFactorAuthentication(_ref) {
  var CancelSectionComponent = _ref.CancelSectionComponent,
      requestSecurityCode = _ref.requestSecurityCode,
      submitSecurityCode = _ref.submitSecurityCode,
      verifiedTwoFactorAuthenticationMethodsData = _ref.verifiedTwoFactorAuthenticationMethodsData,
      primaryBtnText = _ref.primaryBtnText,
      primaryBtnClassName = _ref.primaryBtnClassName,
      PrimaryBtnIcon = _ref.PrimaryBtnIcon,
      primaryBtnIconClassName = _ref.primaryBtnIconClassName,
      plivoUuid = _ref.plivoUuid,
      isSubmittingTwoFactorAuthenticationSecurityCode = _ref.isSubmittingTwoFactorAuthenticationSecurityCode,
      errorMsg = _ref.errorMsg;

  var _useState = useState(Views.VerifiedMethodSelection),
      _useState2 = _slicedToArray(_useState, 2),
      currentView = _useState2[0],
      setCurrentView = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedVerifiedTwoFactorAuthenticationMethodData = _useState4[0],
      setSelectedVerifiedTwoFactorAuthenticationMethodData = _useState4[1];

  return React.createElement(React.Fragment, null, currentView === Views.VerifiedMethodSelection && React.createElement(VerifiedMethodSelection, {
    verifiedTwoFactorAuthenticationMethodsData: verifiedTwoFactorAuthenticationMethodsData,
    setSelectedVerifiedTwoFactorAuthenticationMethodData: setSelectedVerifiedTwoFactorAuthenticationMethodData,
    setCurrentView: setCurrentView
  }), currentView === Views.EnterSecurityCode && React.createElement(EnterSecurityCode, {
    selectedVerifiedTwoFactorAuthenticationMethodData: selectedVerifiedTwoFactorAuthenticationMethodData,
    setCurrentView: setCurrentView,
    requestSecurityCode: requestSecurityCode,
    submitSecurityCode: submitSecurityCode,
    primaryBtnText: primaryBtnText,
    primaryBtnClassName: primaryBtnClassName,
    PrimaryBtnIcon: PrimaryBtnIcon,
    primaryBtnIconClassName: primaryBtnIconClassName,
    plivoUuid: plivoUuid,
    isSubmittingTwoFactorAuthenticationSecurityCode: isSubmittingTwoFactorAuthenticationSecurityCode,
    shouldShowUseDifferentMethodBtn: verifiedTwoFactorAuthenticationMethodsData.length > 1,
    errorMsg: errorMsg
  }), CancelSectionComponent);
};